<i class="pi pi-bell text-3xl cursor-pointer ml-3 mt-2" (click)="showNotificationSidebar = !showNotificationSidebar">
    <span *ngIf="notifications.length > 0" pBadge [value]="notifications?.length"></span>
</i>

<p-sidebar class="noti-bar" [(visible)]="showNotificationSidebar" position="right" >
    <ng-template pTemplate="header">
        <span class="font-semibold text-xl">Notifications</span>
    </ng-template>
    <div class="flex flex-column gap-3" *ngIf="notifications.length">
        <p-card class="relative cursor-pointer" *ngFor="let notification of notifications; let i = index; trackBy: trackByIndex">
            <div class="flex align-items-center gap-3">
                <i class="pi text-xl" 
                   [ngClass]="{
                    'pi-check-circle text-green-500': notification.status === 'success',
                    'pi-times-circle text-red-500': notification.status === 'error',
                    'pi-exclamation-triangle text-yellow-500': notification.status === 'warn',
                    'pi-info-circle text-blue-500': notification.status === 'info'
                   }">
                </i>
                <div class="flex flex-column gap-2">
                    <span class="font-semibold text-base">{{ notification.msg }}</span>
                    <span class="text-base text-gray-500">{{ notification.date }}</span>
                    <i class="pi pi-trash cross absolute" (click)="dismissNotification(i, $event)"></i>
                </div>
            </div>
        </p-card>
    </div>
    <div class="flex flex-column gap-3" *ngIf="!notifications.length">
        <p-card>
            No Notification Found.
        </p-card>
    </div>
</p-sidebar>
